module.exports = __webpack_public_path__ + "img/Mstorybg302.29972719.png";